import styles from "./loading.module.css";

type LoadingProps = {
  size?: "sm" | "md" | "lg";
};

export default function Loading({ size = "lg" }: LoadingProps) {
  return (
    <div className={styles.loadingScreen} aria-label="loading">
      <div className={styles.content}>
        <div className={`${styles.spinner} ${styles[size]}`}>
          <div className={styles.track} />
          <div className={styles.progress} />
          <div className={styles.centerDotWrap}>
            <div className={styles.centerDot} />
          </div>
        </div>
      </div>
    </div>
  );
}
